import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import "./Contact.css";
import NavBar from "../NavBar/NavBar";
import Footer from '../Footer/Footer';
import { Helmet } from 'react-helmet-async';

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    phone: '',
    country: '',
    message: '',
    inquiryType: 'personal',
    receiveUpdates: false
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
    // Clear error for this field
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };
    useEffect(() => {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "instant",   // Change to "smooth" if you prefer
      });
    }, []);

  const validateForm = () => {
    const newErrors = {};

    if (!formData.firstName.trim()) {
      newErrors.firstName = 'First name is required';
    }

    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Last name is required';
    }

    if (!formData.email) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Please enter a valid email address';
    }

    if (!formData.phone) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/.test(formData.phone)) {
      newErrors.phone = 'Please enter a valid phone number';
    }

    if (!formData.country) {
      newErrors.country = 'Country is required';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'Message is required';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    setIsSubmitting(true);
    
    // Simulate API call
    setTimeout(() => {
      setSubmitStatus('success');
      setIsSubmitting(false);
      // Reset form after successful submission
      setFormData({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        country: '',
        message: '',
        inquiryType: 'personal',
        receiveUpdates: false
      });
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 1500);
  };

  const contactInfo = [
    {
      icon: "fa-solid fa-location-dot",
      title: "Visit Us",
      details: "22KG, 13 Avenue, Nyarutarama, Kigali, Rwanda",
      color: "#ef4444"
    },
    {
      icon: "fa-regular fa-envelope",
      title: "Email Us",
      details: "kigaliinternationalgymnasticsa@gmail.com",
      color: "#3b82f6"
    },
    {
      icon: "fa-solid fa-phone",
      title: "Call Us",
      details: ["+250 788488973"],
      color: "#10b981"
    },
    {
      icon: "fa-regular fa-clock",
      title: "Working Hours",
      details: "Monday - Sunday: 9:00 AM - 8:00 PM",
      color: "#f59e0b"
    }
  ];

  return (
   <>
       <Helmet>
        <title>Contact Us</title>
        <meta
        name="description"
        content="We're here to answer your questions and help you get started 
       "/>
       <link rel="canonical" href="/"/>
       </Helmet>
    <div className='kiga-contact-page'>
      <NavBar />

      {/* Hero Section */}
      <section 
        className='contact-hero'
        style={{
          background: `linear-gradient(135deg, rgba(0,0,0,0.75), rgba(0,0,0,0.6)), url('/images/moving2.jpg')`,
          backgroundAttachment: 'fixed',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <div className='contact-hero-content'>
          <span className='hero-subtitle'>Get in Touch</span>
          <h1>Contact Us</h1>
          <p>We're here to answer your questions and help you get started</p>
          <div className='hero-breadcrumb'>
            <Link to="/">Home</Link>
            <span>/</span>
            <span className='current'>Contact</span>
          </div>
        </div>
        <div className='hero-wave'>
          <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
            <path d="M0,64L80,69.3C160,75,320,85,480,80C640,75,800,53,960,48C1120,43,1280,53,1360,58.7L1440,64L1440,120L1360,120C1280,120,1120,120,960,120C800,120,640,120,480,120C320,120,160,120,80,120L0,120Z" />
          </svg>
        </div>
      </section>

      {/* Contact Section */}
      <section className='contact-section'>
        <div className='container'>
          <div className='contact-grid'>
            {/* Contact Information */}
            <div className='contact-info'>
              <div className='info-header'>
                <span className='section-tag'>Contact Information</span>
                <h2>Get in Touch With Us</h2>
                <p>Have questions about our programs? We're here to help!</p>
              </div>
              
              <div className='info-cards'>
                {contactInfo.map((info, index) => (
                  <div key={index} className='info-card' style={{ animationDelay: `${index * 0.1}s` }}>
                    <div className='info-icon' style={{ background: `${info.color}15`, color: info.color }}>
                      <i className={info.icon}></i>
                    </div>
                    <div className='info-details'>
                      <h3>{info.title}</h3>
                      {Array.isArray(info.details) ? (
                        info.details.map((detail, idx) => <p key={idx}>{detail}</p>)
                      ) : (
                        <p>{info.details}</p>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              {/* Social Links */}
              <div className='social-links'>
                <h3>Follow Us</h3>
                <div className='social-icons'>
                  <a href="https://www.facebook.com/pascouwayezu" className='social-icon'><i className="fa-brands fa-facebook-f"></i></a>
                  <a href="https://www.instagram.com/kinternationalgymnastics_kiga/ " className='social-icon'><i className="fa-brands fa-instagram"></i></a>
                  <a href="#" className='social-icon'><i className="fa-brands fa-twitter"></i></a>
                  <a href="https://wa.link/0pahx5" className='social-icon'><i className="fa-brands fa-whatsapp"></i></a>
                  <a href="https://www.linkedin.com/in/pascal-uwayezu-b61180218/" className='social-icon'><i className="fa-brands fa-linkedin"></i></a>
                </div>
              </div>
            </div>

            {/* Contact Form */}
            <div className='contact-form-wrapper'>
              <div className='form-header'>
                <h2>Send Us a Message</h2>
                <p>Fill out the form below and we'll get back to you as soon as possible</p>
              </div>

              {submitStatus === 'success' && (
                <div className='alert-success'>
                  <i className="fa-solid fa-circle-check"></i>
                  Thank you for your message! We'll get back to you soon.
                </div>
              )}

              <form onSubmit={handleSubmit} className='contact-form'>
                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='firstName'>
                      First Name <span className='required'>*</span>
                    </label>
                    <input
                      type='text'
                      id='firstName'
                      name='firstName'
                      value={formData.firstName}
                      onChange={handleChange}
                      className={errors.firstName ? 'error' : ''}
                      placeholder='Enter your first name'
                    />
                    {errors.firstName && <span className='error-message'>{errors.firstName}</span>}
                  </div>

                  <div className='form-group'>
                    <label htmlFor='lastName'>
                      Last Name <span className='required'>*</span>
                    </label>
                    <input
                      type='text'
                      id='lastName'
                      name='lastName'
                      value={formData.lastName}
                      onChange={handleChange}
                      className={errors.lastName ? 'error' : ''}
                      placeholder='Enter your last name'
                    />
                    {errors.lastName && <span className='error-message'>{errors.lastName}</span>}
                  </div>
                </div>

                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='email'>
                      Email Address <span className='required'>*</span>
                    </label>
                    <input
                      type='email'
                      id='email'
                      name='email'
                      value={formData.email}
                      onChange={handleChange}
                      className={errors.email ? 'error' : ''}
                      placeholder='your@email.com'
                    />
                    {errors.email && <span className='error-message'>{errors.email}</span>}
                  </div>

                  <div className='form-group'>
                    <label htmlFor='phone'>
                      Phone Number <span className='required'>*</span>
                    </label>
                    <input
                      type='tel'
                      id='phone'
                      name='phone'
                      value={formData.phone}
                      onChange={handleChange}
                      className={errors.phone ? 'error' : ''}
                      placeholder='+250 XXX XXX XXX'
                    />
                    {errors.phone && <span className='error-message'>{errors.phone}</span>}
                  </div>
                </div>

                <div className='form-row'>
                  <div className='form-group'>
                    <label htmlFor='country'>
                      Country <span className='required'>*</span>
                    </label>
                    <input
                      type='text'
                      id='country'
                      name='country'
                      value={formData.country}
                      onChange={handleChange}
                      className={errors.country ? 'error' : ''}
                      placeholder='Your country'
                    />
                    {errors.country && <span className='error-message'>{errors.country}</span>}
                  </div>

                  <div className='form-group'>
                    <label>Inquiry Type</label>
                    <div className='radio-group'>
                      <label className='radio-label'>
                        <input
                          type='radio'
                          name='inquiryType'
                          value='personal'
                          checked={formData.inquiryType === 'personal'}
                          onChange={handleChange}
                        />
                        <span>Personal</span>
                      </label>
                      <label className='radio-label'>
                        <input
                          type='radio'
                          name='inquiryType'
                          value='organization'
                          checked={formData.inquiryType === 'organization'}
                          onChange={handleChange}
                        />
                        <span>Organization</span>
                      </label>
                    </div>
                  </div>
                </div>

                <div className='form-group'>
                  <label htmlFor='message'>
                    Message <span className='required'>*</span>
                  </label>
                  <textarea
                    id='message'
                    name='message'
                    rows='5'
                    value={formData.message}
                    onChange={handleChange}
                    className={errors.message ? 'error' : ''}
                    placeholder='Tell us how we can help...'
                  ></textarea>
                  {errors.message && <span className='error-message'>{errors.message}</span>}
                </div>

                <div className='form-group checkbox-group'>
                  <label className='checkbox-label'>
                    <input
                      type='checkbox'
                      name='receiveUpdates'
                      checked={formData.receiveUpdates}
                      onChange={handleChange}
                    />
                    <span>I would like to receive logistics related news and marketing updates via email or phone.</span>
                  </label>
                </div>

                <button 
                  type='submit' 
                  className='submit-btn'
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <>
                      <i className="fa-solid fa-spinner fa-spin"></i>
                      Sending...
                    </>
                  ) : (
                    <>
                      Send Message
                      <i className="fa-solid fa-paper-plane"></i>
                    </>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className='map-section'>
        <div className='container'>
          <div className='map-wrapper'>
            <iframe
              title="KIGA Location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3987.4765!2d30.0865!3d-1.9436!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x19dca7b5b8c5b5b5%3A0x5b5b5b5b5b5b5b5b!2sNyarutarama%2C%20Kigali!5e0!3m2!1sen!2srw!4v1234567890"
              width="100%"
              height="400"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className='faq-section'>
        <div className='container'>
          <div className='section-header'>
            <span className='section-tag'>FAQ</span>
            <h2>Frequently Asked Questions</h2>
            <p>Find quick answers to common questions</p>
          </div>
          <div className='faq-grid'>
            <div className='faq-item'>
              <h3>What age groups do you accept?</h3>
              <p>We accept students from 18 months to 17 years old, with programs tailored to each age group's developmental needs.</p>
            </div>
            <div className='faq-item'>
              <h3>Do you offer trial classes?</h3>
              <p>Yes! We offer one free trial class for new students to experience our programs before committing.</p>
            </div>
            <div className='faq-item'>
              <h3>What should my child wear?</h3>
              <p>Comfortable athletic wear, leotard for girls, and bare feet or gymnastics shoes. No jewelry or accessories.</p>
            </div>
            <div className='faq-item'>
              <h3>How do I register?</h3>
              <p>Simply create an account on our parent portal, add your child, and select your preferred class.</p>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  </>
  );
};

export default Contact;